import { Endpoint } from '../endpoint';

export const DataElementView = new Endpoint('data_element_view');
